import React from "react"
import {
  Select as ChakraReactSelect,
  ChakraStylesConfig,
  GroupBase,
  ReactSelectBaseProps,
} from "chakra-react-select"

/** Common option shape: a display label and string value. */
export type SelectOption = { label: string; value: string }

// Shared chakra-react-select wrapper: Chakra Input sizing + a de-emphasized
// indicator area, applied to every dropdown for a consistent look.
const baseChakraStyles: ChakraStylesConfig<any, boolean, any> = {
  dropdownIndicator: (provided) => ({
    ...provided,
    bg: "transparent",
    borderLeftWidth: 0,
    px: 2,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
}

const Select = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
    props: Partial<ReactSelectBaseProps<Option, IsMulti, Group>>,
  ) => (
    <ChakraReactSelect
      size="md"
      chakraStyles={baseChakraStyles}
      {...props}
    />
  )

export default Select
